__webpack_require__.p = "/getting-started/system-email-templates/";